import { render, staticRenderFns } from "./form.page.vue?vue&type=template&id=2217908e"
import script from "./form.page.vue?vue&type=script&lang=ts"
export * from "./form.page.vue?vue&type=script&lang=ts"
import style0 from "./form.page.vue?vue&type=style&index=0&id=2217908e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports